import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/navigation/Navigation';
import ShopCategory from './pages/ShopCategory';
import Shop from './pages/Shop';
import Gallery from './pages/Gallery';
import Product from './pages/Product';
import CustomizeBlouse from './pages/CustomizeBlouse';
import Cart from './pages/Cart';
import LoginSignup from './pages/LoginSignup';
import Footer from './components/footer/Footer';
import men_banner from './components/assets/cloths/banner_mens.png';
import women_banner from './components/assets/cloths/banner_women.png';
import kid_banner from './components/assets/cloths/banner_kids.png';

function App() {
  return (
    <div className="app-width max-w-screen-2xl w-full">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path='/' element={<Shop />} />
          <Route path='/sweet' element={<ShopCategory banner={men_banner} category="sweet" />} />
          <Route path='/semi-sweet' element={<ShopCategory banner={women_banner} category="semi-sweet" />} />
          <Route path='/snack' element={<ShopCategory banner={kid_banner} category="snack" />} />
          <Route path='/cake' element={<ShopCategory category="cake" />} />
          <Route path='/tailor' element={<ShopCategory category="tailoring" />} />
          <Route path='/tailor/design-your-blouse' element={<CustomizeBlouse />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/product/:productId' element={<Product />} />
          <Route path='/cart' element={<Cart />} />
          {/* <Route path='/login' element={<LoginSignup />} /> */}
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
